const styles = theme => ({
    inputRoot: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        boxShadow: 'none',
        border: `solid 2px ${theme.palette.common.border}`
    },
    inputFocus: {
        border: `solid 2px ${theme.palette.primary.main}`
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    icon: {
        color: theme.palette.secondary.dark,
        stroke: theme.palette.secondary.dark,
    }
});

export default styles;